import React from 'react'
import { Link } from 'react-router-dom'
import awsCloudLogo from '../assets/aws-cloud.svg'

const techStack = [
  { name: 'iOS', logo: 'https://cdn.simpleicons.org/apple/FFFFFF' },
  { name: 'Android', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/android/android-original.svg' },
  { name: 'React Native', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg' },
  { name: 'JavaScript', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg' },
  { name: 'TypeScript', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg' },
  { name: 'HTML', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg' },
  { name: 'CSS', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg' },
  { name: 'Flutter', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg' },
  { name: 'Swift', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/swift/swift-original.svg' },
  { name: 'Kotlin', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg' },
  { name: 'Node.js', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg' },
  { name: 'Firebase', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg' },
  { name: 'AWS', logo: awsCloudLogo },
  { name: 'Laravel', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/laravel/laravel-original.svg' },
  { name: 'MongoDB', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg' },
  { name: 'PostgreSQL', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg' },
]

const MobileAppTechStack = () => {
  return (
    <section className="mobile-tech-stack-section py-5">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-lg-5 mb-4 mb-lg-0">
            <h2 className="pb-3 h5 app-section-eyebrow">TECH STACK</h2>
            <h3 className="display-5 fw-bold text-white">Tech Stack Our Mobile App Development Company Uses</h3>
            <p className="lead text-white-50 mt-3">
              We choose technology around product goals, not trends. Whether you need to hire app developer support or a full squad, our stack supports fast releases, secure APIs, custom app development, and long-term scale.
            </p>
            <Link
              to="/contact"
              className="btn btn-outline-light rounded-4 px-4 py-2 mt-2"
              onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
            >
              Talk to App Experts
            </Link>
          </div>
          <div className="col-12 col-lg-7">
            <div className="mobile-tech-stack-panel">
              <div className="row">
                {techStack.map((tech) => (
                  <div className="col-6 col-md-4 my-2" key={tech.name}>
                    <div className="mobile-tech-item h-100">
                      <span className="mobile-tech-icon">
                        <img src={tech.logo} alt={`${tech.name} logo`} loading="lazy" />
                      </span>
                      <span>{tech.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default MobileAppTechStack
